import React, { useEffect } from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Label,
  LabelList,
  Cell,
  Text,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { getExpertAnalytics } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { Spin, Dropdown } from "antd";
import { Tooltip as Tooltip2 } from "@mui/material";
import VizHeader from "../VizHeader/VizHeader";
import FileSaver, { saveAs } from "file-saver";
import * as htmlToImage from "html-to-image";
import { useCurrentPng } from "recharts-to-png";

export default function QuestionsAnsweredGraphExpertOverview() {
  const [loading, setLoading] = React.useState(false);
  const expertOverview = useSelector((state) => state.expertOverviewCmReducer);
  const dispatch = useDispatch();
  const { getExpertAnalyticsDataInCmOverview } = bindActionCreators(
    Actions,
    dispatch
  );
  const cmRootReducer = useSelector((state) => state.cmRoot);
  const data2 = expertOverview.expertAnalyticsQuestions;

  const [getPieChartPng, { ref: pieChartRef }] = useCurrentPng();

  const tickFormatter = (value) => {
    const limit = 10;
    if (value.length <= limit) return value;
    else {
      return `${value.substring(0, limit)}...`;
    }
  };

  function downloadSvgAsJpeg() {
    htmlToImage
      .toJpeg(
        document.getElementsByClassName("recharts-wrapper")[0],
        { quality: 0.8, backgroundColor: "#fff" },
        { backgroundColor: "#fff" }
      )
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = "questions-answered-top-20.jpeg";
        link.href = dataUrl;
        link.click();
      });
  }

  const handleDownloadSVG = () => {
    const chartContainer =
      document.getElementsByClassName("recharts-wrapper")[0];
    const chartSvg = chartContainer.querySelector("svg");
    const chartXml = new XMLSerializer().serializeToString(chartSvg);
    const svgBlob = new Blob([chartXml], {
      type: "image/svg+xml;charset=utf-8",
    });
    saveAs(svgBlob, "questions-answered-top-20.svg");
  };

  // const handleAreaDownload = React.useCallback(async () => {
  // 	const png = await getPieChartPng();
  // 	if (png) {
  // 		FileSaver.saveAs(png, "questions-answered-top-15.png");
  // 	}
  // }, [getPieChartPng]);

  const handleAreaDownload = () => {
    htmlToImage
      .toJpeg(
        document.getElementsByClassName("recharts-wrapper")[0],
        { quality: 0.8, backgroundColor: "#fff" },
        { backgroundColor: "#fff" }
      )
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = `questions-answered-top-20.png`;
        link.href = dataUrl;
        link.click();
      });
  };

  const items = [
    {
      key: "1",
      label: (
        // <a target="_blank" rel="noopener noreferrer" href="https://www.antgroup.com">
        //   1st menu item
        // </a>
        <div onClick={() => handleAreaDownload()}>Download as PNG Image</div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={() => downloadSvgAsJpeg()}>Download as JPEG Image</div>
      ),
    },
    {
      key: "4",
      label: (
        <div onClick={() => handleDownloadSVG()}>Download SVG Vector image</div>
      ),
    },
  ];

  const truncate = (str, max = 8) => {
    if (!str) return "";
    return str.length > max ? str.substring(0, max) + "…" : str;
  };
  const CustomTick = ({ x, y, payload }) => {
    const fullName = payload?.value || "";
    const parts = fullName.split(" ");
    const first = parts[0] || "";
    const last = parts.slice(1).join(" "); // supports middle names too

    // value shown in the axis (first line + second line)
    const displayValue = last ? `${first}\n${last}` : first;
    console.log(displayValue);
    return (
      <Tooltip2 title={fullName} placement="top">
        <g transform={`translate(${x},${y})`}>
          <Text
            x={0}
            y={0}
            textAnchor="end"
            verticalAnchor="start"
            angle={-35} // slanted
            fontSize={11}
          >
            {truncate(fullName, 16)}
          </Text>
        </g>
      </Tooltip2>
    );
  };

  const CustomizedTooltipForGlobalAndCountry = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0 && payload[0].value > 0) {
      return (
        <>
          <p
            className="custom-tooltip"
            style={{
              backgroundColor: "#fff",
              border: "1px solid #ececec",
              padding: "7px",
            }}
          >
            {payload.map((obj, ind) => {
              return (
                <>
                  <p className="label">{obj.payload.name}</p>
                  <p
                    className="label"
                    style={{ color: obj.fill, textTransform: "capitalize" }}
                  >
                    {obj.dataKey}: {obj.value.toLocaleString()}
                  </p>
                </>
              );
            })}
          </p>
        </>
      );
    }
  };

  useEffect(() => {
    setLoading(true);
    if (expertOverview.expertAnalyticsData !== null) {
      setLoading(false);
    }
  }, [
    cmRootReducer.selecetdRoutingValue,
    cmRootReducer.selectedGeoLevel.length !== 0 &&
      cmRootReducer.selectedGeoLevel.label,
    cmRootReducer.selectedDomainIds,
  ]);

  // console.log("pieChartRef",pieChartRef);
  // console.log("data2",data2)
  return (
    <>
      {/* <div style={{paddingTop:'5px',width:'100%',display:'flex' }}>
				<div style={{width:'30%'}}></div>
				<div style={{width:'40%'}}>
                <VizHeader type={4}>Questions Answered - Top 15</VizHeader>
				</div>
				<div style={{width:'30%',display:'flex',justifyContent:'flex-end',paddingLeft:'7px'}}>
				<Dropdown
						menu={{
							items,
						}}
					>
						<a onClick={(e) => e.preventDefault()}>
							<i
								className="fa fa-ellipsis-h"
								style={{ fontSize: "20px", color: "lightgray", padding: '5px' }}
							></i>
						</a>
					</Dropdown>
				</div>
              </div> */}
      <div
        style={{
          paddingTop: "5px",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div></div>
        <div>
          <VizHeader type={4} isBold={true}>
            Questions Answered - Top 20
          </VizHeader>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingLeft: "7px",
          }}
        >
          <Dropdown
            menu={{
              items,
            }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <i
                className="fa fa-ellipsis-h"
                style={{ fontSize: "20px", color: "lightgray", padding: "5px" }}
              ></i>
            </a>
          </Dropdown>
        </div>
      </div>
      <Spin spinning={loading}>
        <ResponsiveContainer width={"100%"} height={420}>
          <BarChart
            width={600}
            height={420}
            data={data2}
            margin={{
              top: 25,
              right: 30,
              left: 20,
              bottom: 40,
            }}
            barSize={20}
            ref={pieChartRef}
          >
            <XAxis
              tick={<CustomTick />}
              fontSize={12}
              dataKey="name"
              interval={0}
              angle={-45}
              dy={18}
              minTickGap={-200}
              height={40}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              fontSize={12}
              dataKey="answers"
              tickFormatter={(value) =>
                new Intl.NumberFormat("en-US", {
                  notation: "compact",
                  compactDisplay: "short",
                }).format(value)
              }
              label={{
                value: "Answers",
                angle: -90,
                position: "insideLeft",
                fontWeight: "bold",
              }}
            />
            <Tooltip
              wrapperStyle={{ fontWeight: "bold", fontSize: "12px" }}
              content={<CustomizedTooltipForGlobalAndCountry />}
            />
            <CartesianGrid stroke="#ececec" vertical={false} />
            <Bar dataKey="answers" fill="#009bff" background={{ fill: "none" }}>
              {/* <LabelList fontSize={12} dataKey='answers' position="top" /> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    </>
  );
}
